import { render, staticRenderFns } from "./RepresentacaoConjuntoCadastro.vue?vue&type=template&id=2c757000"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports